import intersection from 'lodash/intersection';

export const shallowEqualArraysUnordered = <T>(array1: T[], array2: T[]) => {
    if (array1.length !== array2.length) {
        return false;
    }

    return intersection(array1, array2).length === array1.length;
};
